import { render } from "./blockchainVeteransScreen.vue?vue&type=template&id=b98d7200"
import script from "./blockchainVeteransScreen.vue?vue&type=script&lang=js"
export * from "./blockchainVeteransScreen.vue?vue&type=script&lang=js"

import "./blockchainVeteransScreen.vue?vue&type=style&index=0&id=b98d7200&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__